import{e as T,m as A}from"./chunk-HBP5N4FR.js";var o,R,O,I,c,n,_=T(()=>{A();o="cancel-transaction-toast",R=6e3,O=5,I=9e4,c=6e5,n=2e4});export{o as a,R as b,O as c,I as d,c as e,n as f,_ as g};
//# sourceMappingURL=chunk-MDZJ7LZR.js.map
